import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import styled from 'styled-components/native';

interface Props {
  onPressNumber(number: string): void;
  onPressRemove(): void;
  onPressClear(): void;
}

export const PinGrid = (props: Props) => {
  const { onPressNumber } = props;

  return (
    <Container>
      <Row>
        <NumberButton number="1" onPress={onPressNumber} />
        <NumberButton number="2" onPress={onPressNumber} />
        <NumberButton number="3" onPress={onPressNumber} />
      </Row>
      <Row>
        <NumberButton number="4" onPress={onPressNumber} />
        <NumberButton number="5" onPress={onPressNumber} />
        <NumberButton number="6" onPress={onPressNumber} />
      </Row>
      <Row>
        <NumberButton number="7" onPress={onPressNumber} />
        <NumberButton number="8" onPress={onPressNumber} />
        <NumberButton number="9" onPress={onPressNumber} />
      </Row>
      <Row>
        <Button onPress={props.onPressRemove}>
          <FontAwesomeIcon icon="delete-left" color="white" size={20} />
        </Button>

        <NumberButton number="0" onPress={onPressNumber} />

        <Button onPress={props.onPressClear}>
          <CancelText weight="semibold" color="white">
            Cancel
          </CancelText>
        </Button>
      </Row>
    </Container>
  );
};

const NumberButton = (props: {
  number: string;
  onPress: (number: string) => void;
}) => {
  const handlePress = () => props.onPress(props.number);

  return (
    <Button onPress={handlePress}>
      <Text weight="semibold" color="white">
        {props.number}
      </Text>
    </Button>
  );
};

const Container = styled.View`
  gap: 8px;
`;

const Row = styled.View`
  flex-direction: row;
  gap: 8px;
`;

const Button = styled.TouchableOpacity`
  background-color: ${colors.primary[700]}
  color: white;

  align-items: center;
  justify-content: center;

  width: 80px;
  height: 40px;
  border-radius: 8px;
`;

const CancelText = styled(Text)`
  font-size: 14px;
`;
